import SidebarLayout from '../../components/SidebarLayout';
import AssessmentsForm from '../../components/sections/MTSS/AssessmentsForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';

export default function Assessments() {
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/add-assessment');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<AssessmentsForm />}
          heading={'Add Assessment'}
        />
      </div>
    </AccessWrapper>
  );
}
